<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 700">
    <g id="Graphics">
      <polygon
        class="cls-1"
        points="420.13 668.7 681.03 668.7 745.46 269.66 129 269.66 64.57 668.7 339.24 668.7 420.13 668.7"
      />
      <polygon
        class="cls-2"
        points="489.23 269.66 750.13 269.66 500.86 30.28 482.18 42.33 133.66 269.66 408.33 269.66 489.23 269.66"
      />
      <polygon
        class="cls-2"
        points="389.89 266.77 129 266.77 375.3 432.16 393.98 420.11 745.46 266.77 470.79 266.77 389.89 266.77"
      />
      <path
        class="cls-2"
        d="M333.74,673.94H64.57a5.24,5.24,0,0,1-5.17-6.07l64.43-399a5.23,5.23,0,0,1,5.17-4.4H745.46a5.23,5.23,0,0,1,5.17,6.06l-64.43,399a5.24,5.24,0,0,1-5.17,4.4H333.74Zm86.39-10.47H676.57L739.31,274.9H133.45L70.72,663.47H420.13Z"
      />
      <path
        class="cls-2"
        d="M501.73,25.86a5.26,5.26,0,0,1,3.67,1.49L749.12,265.92a5.23,5.23,0,1,1-7.32,7.48L501.05,37.75,131.82,274.07a5.24,5.24,0,0,1-5.65-8.82L498.91,26.68A5.27,5.27,0,0,1,501.73,25.86Z"
      />
      <path
        class="cls-2"
        d="M374.78,438.07a5.26,5.26,0,0,1-3.67-1.49L125.33,273a5.24,5.24,0,1,1,7.33-7.48l242.8,160.67L742.64,264.84a5.23,5.23,0,1,1,5.64,8.82L377.6,437.25A5.27,5.27,0,0,1,374.78,438.07Z"
      />
      <path
        class="cls-2"
        d="M681,673.94a5.24,5.24,0,0,1-3.81-1.65L425.94,408.2a5.23,5.23,0,1,1,7.61-7.18L684.84,665.11a5.24,5.24,0,0,1-3.81,8.83Z"
      />
      <path
        class="cls-2"
        d="M64.57,673.94a5.24,5.24,0,0,1-4-8.65c.53-.62,53.57-62.23,107-123.09C277.05,417.42,306.05,383.93,309.76,383.77a5.52,5.52,0,0,1,4.08,1.55,5.23,5.23,0,0,1,.08,7.4,5.16,5.16,0,0,1-2.5,1.43C297.32,404.44,149,578.6,68.54,672.12A5.24,5.24,0,0,1,64.57,673.94ZM281.42,426.18Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0h0Z"
      />
      <polygon
        class="cls-1"
        points="450.48 430.7 673.79 430.7 728.93 91.31 201.28 91.31 146.13 430.7 381.23 430.7 450.48 430.7"
      />
      <path
        class="cls-2"
        d="M376.53,435.15H146.13a4.5,4.5,0,0,1-3.41-1.56,4.45,4.45,0,0,1-1-3.6L196.86,90.6a4.47,4.47,0,0,1,4.42-3.75H728.93a4.53,4.53,0,0,1,3.42,1.57,4.44,4.44,0,0,1,1,3.6L678.21,431.41a4.46,4.46,0,0,1-4.42,3.74H376.53Zm74-8.9H670l53.7-330.49H205.09L151.4,426.25H450.48Z"
      />
      <polygon
        class="cls-1"
        points="419.86 663.47 676.05 663.47 739.31 269.66 371.73 434.39 133.98 269.66 70.72 663.47 340.42 663.47 419.86 663.47"
      />
      <path
        class="cls-2"
        d="M374.78,438.28a5.26,5.26,0,0,1-3.67-1.49L125.33,273.19a5.24,5.24,0,1,1,7.33-7.48l242.8,160.68L742.64,265.05a5.23,5.23,0,1,1,5.64,8.81L377.6,437.45A5.2,5.2,0,0,1,374.78,438.28Z"
      />
      <path
        class="cls-2"
        d="M681,674.14a5.23,5.23,0,0,1-3.81-1.64L429.55,412a5.24,5.24,0,0,1,7.62-7.19L684.84,665.32a5.23,5.23,0,0,1-3.81,8.82Z"
      />
      <path
        class="cls-2"
        d="M64.57,674.14a5.23,5.23,0,0,1-4-8.65c.53-.61,53.57-62.22,107-123.08C277.05,417.63,303.26,384.14,307,384a5.51,5.51,0,0,1,4.07,1.55,5.24,5.24,0,0,1-2.42,8.83c-14.1,10.29-159.6,184.45-240.09,278A5.21,5.21,0,0,1,64.57,674.14ZM281.42,426.39Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0Z"
      />
      <path
        class="cls-2"
        d="M785.74,247.64a5.28,5.28,0,0,0,4.74-.51l140.89-92.26a5.24,5.24,0,0,0-5.74-8.76L784.74,238.37a5.24,5.24,0,0,0,1,9.27Z"
      />
      <path
        class="cls-2"
        d="M805.39,278.25a5.12,5.12,0,0,0,2.32.32l76.95-6.79a5.24,5.24,0,0,0-.92-10.43l-77,6.79a5.23,5.23,0,0,0-1.4,10.11Z"
      />
      <path
        class="cls-2"
        d="M757.11,223.66a5.24,5.24,0,0,0,6.19-1.95L810,153.08a5.24,5.24,0,0,0-8.66-5.89l-46.68,68.63a5.23,5.23,0,0,0,1.38,7.27A4.94,4.94,0,0,0,757.11,223.66Z"
      />
      <circle class="cls-2" cx="927.42" cy="268.89" r="13.24" />
      <circle class="cls-2" cx="424.32" cy="264.77" r="119.87" />
      <circle class="cls-3" cx="411.98" cy="255.35" r="119.87" />
      <path
        class="cls-1"
        d="M378.08,214.12q.36-6,5.06-8.49l28.32-15.85a13.26,13.26,0,0,1,6.79-1.9,11.08,11.08,0,0,1,10.13,11.47l-6.74,108.73A10.25,10.25,0,0,1,418,315.4a10.77,10.77,0,0,1-17.82-8.65l5.58-90-11.48,6.71a9.8,9.8,0,0,1-6.33,1.64,10.13,10.13,0,0,1-7.17-3.5A9.82,9.82,0,0,1,378.08,214.12Z"
      />
    </g>
  </svg>
</template>

<style scoped>
.cls-1 {
  fill: #fff;
}
.cls-2 {
  fill: #0a0a0a;
}
.cls-3 {
  fill: #ed7150;
}
</style>
